var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirspace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 542,
    viewBox: "0 0 239 542",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M64.2924 213.027L166.913 537.843L152.155 542L43.069 215.366C40.5769 207.902 61.9572 205.626 64.2924 213.027Z",
    fill: "url(#paint0_linear_6_6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M136.38 173.138L239.001 497.954L224.243 502.11L115.157 175.477C112.665 168.013 134.045 165.737 136.38 173.138Z",
    fill: "url(#paint1_linear_6_6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.933 214.24L96.9718 222.943L70.7517 231.406L20.8538 76.2568C13.2835 52.7156 14.2313 31.1677 21.1426 5.40695L21.3497 4.63356C21.7327 3.21254 22.85 1.84182 24.4946 0.980406C27.0746 -0.37145 30.0877 -0.245696 31.7951 1.14389L32.517 1.73493C32.9564 2.09333 33.3895 2.45173 33.8226 2.81642C53.709 19.3405 66.6338 36.0532 74.041 59.0976L123.939 214.247L123.933 214.24Z",
    fill: "url(#paint2_radial_6_6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.207 216.108L129.883 222.987L84.3294 81.3435C80.1362 68.3091 78.8556 54.5076 80.5818 40.9136L80.6321 40.5049C80.7262 39.7567 81.128 39.065 81.7745 38.6752C82.7852 38.059 84.0406 38.2665 84.8127 39.0902L85.1391 39.4423C94.4546 49.4649 101.46 61.4241 105.653 74.4585L151.207 216.102V216.108Z",
    fill: "#F2F3F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.146 172.383C135.489 174.043 133.562 175.458 131.271 176.52C125.947 178.985 120.273 178.885 115.107 177.03L129.89 222.993L151.213 216.114L137.152 172.389L137.146 172.383Z",
    fill: "#A0EAFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3731 241.869L50.0493 248.747L4.49532 107.111C0.302116 94.0698 -0.978443 80.2683 0.741524 66.6806L0.791742 66.2719C0.885901 65.5237 1.28764 64.832 1.9342 64.4422C2.94484 63.826 4.20029 64.0335 4.97239 64.8572L5.29881 65.2093C14.6142 75.2319 21.6197 87.1911 25.8129 100.226L71.3669 241.869H71.3731Z",
    fill: "#F2F3F4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3411 192.032C54.3367 193.78 53.2005 195.459 51.9325 197.081C47.9904 202.149 43.6779 207.399 37.3065 209.154L50.0431 248.754L71.3669 241.875L55.3348 192.032H55.3411Z",
    fill: "#CDEDF6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.395 111.034L115.163 231.563C108.17 237.888 92.8288 242.837 83.4631 241.793L44.6948 121.264C39.0955 103.854 38.0912 85.3237 41.732 67.4603C42.2718 64.8132 45.4669 63.7883 47.4443 65.618C53.4139 71.1449 58.7057 77.3257 63.2378 84.0158C68.8497 92.3093 73.294 101.401 76.3887 111.034H76.395Z",
    fill: "#161632"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157.133 196.088C155.896 192.233 151.973 189.92 148.012 190.693L140.14 192.233C128.967 194.422 117.385 192.73 107.298 187.442L103.462 185.43L116.889 227.181L159.707 213.366C161.201 212.882 162.023 211.279 161.54 209.782L157.133 196.082V196.088Z",
    fill: "url(#paint3_linear_6_6)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M129.005 218.139C138.552 215.058 153.09 210.367 153.09 210.367C154.214 210.003 154.829 208.795 154.471 207.67C154.471 207.67 152.594 201.835 151.665 198.942",
    stroke: "white",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3939 235.694C33.1572 231.84 34.9839 227.671 38.6561 225.98L45.944 222.628C56.2889 217.868 64.713 209.726 69.8227 199.534L71.7623 195.66L85.1894 237.411L42.3722 251.225C40.8783 251.709 39.2776 250.885 38.7942 249.389L34.3876 235.688L34.3939 235.694Z",
    fill: "url(#paint4_linear_6_6)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1275 106.652L116.896 227.181C109.903 233.506 94.5613 238.454 85.1957 237.411L46.4274 116.882C40.8281 99.471 39.8237 80.9411 43.4645 63.0778C44.0044 60.4306 47.1995 59.4057 49.1768 61.2355C55.1465 66.7624 60.4382 72.9432 64.9704 79.6333C70.5822 87.9268 75.0265 97.0188 78.1212 106.652H78.1275Z",
    fill: "url(#paint5_linear_6_6)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5917 100.791C60.2812 101.294 57.9774 102.036 53.3699 104.734C52.0705 105.495 50.4008 104.847 49.9363 103.413L49.8609 103.187C49.5847 102.338 49.8107 101.401 50.451 100.773C54.8514 96.4592 59.5593 94.9375 65.6482 95.8681C66.527 96.0002 67.2615 96.6352 67.5314 97.4841L67.6067 97.7104C68.0712 99.144 67.092 100.647 65.5917 100.791Z",
    fill: "url(#paint6_linear_6_6)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.767 230.714L104.63 237.216L100.757 225.175C99.4137 220.993 101.705 216.504 105.886 215.158L110.901 213.542C115.075 212.197 119.557 214.492 120.901 218.68L124.774 230.72L124.767 230.714Z",
    fill: "#161632"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.346 222.425L88.3588 220.807C92.5352 219.459 97.0144 221.759 98.3601 225.942L102.234 237.983L82.0927 244.484L78.2193 232.443C76.8736 228.259 79.1697 223.773 83.346 222.425Z",
    fill: "#161632"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.938 244.101C103.488 244.572 101.931 243.767 101.46 242.315L94.2475 219.899C93.2117 216.686 92.8979 213.278 93.3247 209.927L93.3373 209.826C93.3624 209.644 93.4628 209.474 93.6197 209.374C93.8708 209.223 94.1784 209.273 94.3667 209.474L94.4483 209.562C96.7458 212.033 98.4721 214.982 99.5078 218.195L106.72 240.611C107.191 242.064 106.388 243.623 104.938 244.094V244.101Z",
    fill: "#F2F3F4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8903 111.512C49.6413 148.056 64.7883 195.145 64.7883 195.145L65.1963 195.013",
    stroke: "white",
    strokeWidth: 0.31,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2652 120.208C77.9642 88.172 67.4561 55.5011 67.4561 55.5011C62.1769 39.0776 53.439 26.6217 40.4451 14.7442",
    stroke: "white",
    strokeWidth: 0.31,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6786 15.4924C20.1884 29.6586 19.0648 42.3283 20.9856 55.1615",
    stroke: "white",
    strokeWidth: 0.31,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M118.371 221.195C119.068 223.351 120.8 228.746 120.8 228.746C120.8 228.746 112.847 231.312 108.886 232.588",
    stroke: "white",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M110.254 103.514C114.517 116.768 123.801 145.635 129.758 164.159",
    stroke: "white",
    strokeWidth: 0.31,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_6",
    x1: 110.393,
    y1: 403.832,
    x2: 78.3726,
    y2: 243.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FEFEFE",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FBFBFB",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F7F7F7",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F1F1F1",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_6",
    x1: 176.967,
    y1: 335.949,
    x2: 171.356,
    y2: 228.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FEFEFE",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FBFBFB",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F7F7F7",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F1F1F1",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_6_6",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.88451 19.9567) scale(201.079 201.414)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A0EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4CC0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2BB0D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2AABD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#289EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2589AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#216C8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#1C4564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#161834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#161632"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#171834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1D203C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#262E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#33425D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#445D76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#597C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#71A3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#8DCDE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A0EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_6",
    x1: 183.939,
    y1: 232.439,
    x2: 98.3514,
    y2: 192.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#00FFDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#00FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#01F0D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#03DEC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#05C4B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#08A39A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#0C7B7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#104C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#161632"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_6",
    x1: 33.6908,
    y1: 280.538,
    x2: 79.9895,
    y2: 198.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#00FFDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#00FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#01F0D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#03DEC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#05C4B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#08A39A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0C7B7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#104C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#161632"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_6",
    x1: 22.3958,
    y1: 136.255,
    x2: 133.841,
    y2: 168.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F5FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DCF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#B3EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#A0EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6_6",
    x1: 49.748,
    y1: 100.332,
    x2: 67.7197,
    y2: 100.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2BB0D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#1F5B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#161632"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirspace);
export default __webpack_public_path__ + "static/media/airspace.cb2947fcb6f5c534d4b3d1e42a497417.svg";
export { ForwardRef as ReactComponent };